import React from "react";
import { Facebook, Twitter, Linkedin, Instagram, Send, MapPin, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
const SHARED_DATA = {
  businessName: "Chubby Nest",
  vision: "Your home, our nest, we'll take care of the rest. Premium, tech-driven property management for a truly hands-off experience.",
  address: "456 Boutique Lane, Suite 100, Austin, TX 78701",
  phone: "+1 (800) 123-NEST",
  email: "hello@chubbynest.com",
  services: ["Short-Term Rentals", "Mid-Term Rentals", "Property Showcase", "Owner Transparency", "Boutique Hospitality"]
};
function FooterMenuLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="26954" className="flex flex-col gap-2">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-4 w-24 animate-pulse rounded bg-muted/20" />)}
      </div>;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-sm font-sans text-muted-foreground transition-colors hover:text-secondary">
          {item.label}
        </Link>)}
    </nav>;
}
function FooterContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="rounded-xl border border-secondary/30 bg-secondary/10 p-6 text-center">
        <p className="text-sm font-sans text-secondary">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="space-y-3">
        <FormField control={control} name="name" rules={{
        required: "Name is required"
      }} render={({
        field
      }) => <FormItem>
              <FormControl>
                <Input placeholder="Your Name" className="bg-muted/10 border-muted/20 focus-visible:ring-secondary/50" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormControl>
                <Input type="email" placeholder="Email Address" className="bg-muted/10 border-muted/20 focus-visible:ring-secondary/50" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="company" render={({
        field
      }) => <FormItem>
              <FormControl>
                <Input placeholder="Property Address (Optional)" className="bg-muted/10 border-muted/20 focus-visible:ring-secondary/50" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="message" render={({
        field
      }) => <FormItem>
              <FormControl>
                <textarea className="flex min-h-[80px] w-full rounded-lg border border-muted/20 bg-muted/10 px-3 py-2 text-sm shadow-xs placeholder:text-muted-foreground focus-visible:border-secondary focus-visible:ring-secondary/50 focus-visible:ring-[3px] focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 font-sans" placeholder="Tell us about your property..." {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {submitError && <p className="text-xs text-destructive font-sans">{submitError}</p>}

        <Button type="submit" className="w-full bg-secondary hover:bg-secondary/90 text-secondary-foreground rounded-full font-sans transition-all" disabled={isSubmitting}>Submit</Button>
      </div>
    </Form>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="dark relative overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573616/img/deep_space_bg.png)] bg-cover bg-center opacity-5 mix-blend-soft-light" />
      <div className="absolute inset-0 z-0 bg-gradient-to-t from-background via-background/98 to-background/90" />

      <div className="relative z-10 mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-4">
          {}
          <div className="space-y-6">
            <Link to="/HomePage" className="block">
              
            </Link>
            
            <div className="space-y-3 text-sm font-sans text-muted-foreground/80">
              
              
              <div className="flex items-center gap-3">
                <Mail className="h-4 w-4 shrink-0 text-secondary" />
                <span>kenny@chubbynest.com</span>
              </div>
            </div>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-xs font-serif font-semibold uppercase tracking-widest text-foreground/80">
              Navigation
            </h3>
            <MenuProvider menu_id="17" className="w-full">
              <FooterMenuLinks />
            </MenuProvider>
          </div>

          {}
          

          {}
          
        </div>

        <Separator className="my-12 bg-border/20" />

        {}
        <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
          <p className="text-xs font-sans text-muted-foreground/60">© 2026 Chubby Nest LLC. All rights reserved.</p>

          <div className="flex items-center gap-6">
            <a href="https://instagram.com/chubbynest" target="_blank" rel="noopener noreferrer" className="text-muted-foreground/70 transition-colors hover:text-secondary">
              <Instagram className="h-4 w-4" />
              <span className="sr-only">Instagram</span>
            </a>
            <a href="https://www.facebook.com/chubbynest" target="_blank" rel="noopener noreferrer" className="text-muted-foreground/70 transition-colors hover:text-secondary">
              <Facebook className="h-4 w-4" />
              <span className="sr-only">Facebook</span>
            </a>
            <a href="https://www.linkedin.com/company/chubbynest" target="_blank" rel="noopener noreferrer" className="text-muted-foreground/70 transition-colors hover:text-secondary">
              <Linkedin className="h-4 w-4" />
              <span className="sr-only">LinkedIn</span>
            </a>
          </div>

          <div className="flex gap-6">
            <Link to="#" className="text-xs font-sans text-muted-foreground/60 transition-colors hover:text-secondary">
              Privacy Policy
            </Link>
            <Link to="#" className="text-xs font-sans text-muted-foreground/60 transition-colors hover:text-secondary italic">Made with love for Homes ❤️</Link>
          </div>
        </div>
      </div>
    </section>;
}